/* eslint-disable */
(function ($) {
  $.Redactor.opts.langs.EN = require('transifex/languages/en.json').redactor;
})(jQuery);
